import api from '../store/apiClient';

/** Active gateways for resolved store (public, no auth). */
export async function getActivePaymentMethods() {
  const { data } = await api.get('/payment-methods/active');
  const body = data ?? {};
  return Array.isArray(body.data) ? body.data : [];
}
